export const ANIMATE_OUT_SPEED = 200;
export const DEBOUNCE_TIME_DEFAULT = 100;
export const DEBOUNCE_TIME_SCROLL = 2000;
